import { render, staticRenderFns } from "./OrgDetail.vue?vue&type=template&id=5dddcf36"
import script from "./OrgDetail.vue?vue&type=script&lang=js"
export * from "./OrgDetail.vue?vue&type=script&lang=js"
import style0 from "./OrgDetail.vue?vue&type=style&index=0&id=5dddcf36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports